import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';

export function P00045Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('cnSAlarme') === 1) {
    if (getValue('cnSEtatConnexionHTTPS') === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.LINK,
        functionalityTitle: 'P00045.parametre.status.cloud.etatCo',
        title: 'P00045.parametre.status.cloud.tpsReel',
      });
    }

    if (getValue('cnSEtatConnexionMQTT') === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.LINK,
        functionalityTitle: 'P00045.card.state.link.title',
        title: 'P00045.parametre.status.cloud.tpsReel',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.LINK,
        functionalityTitle: 'P00045.status.coProduit',
        title: 'P00045.parametre.status.cloud.tpsReel',
      });
    }
  }

  return res;
}
